import { GraphQLClient } from 'graphql-request'
import { API_BASE_URL } from '@/environment.ts'
import { getHeaders } from '@/service/v3/apiV3Utils.ts'

const graphqlClient = new GraphQLClient(
  `${API_BASE_URL}/api/bff/manager/graphql`,
  {
    headers: await getHeaders(),
  }
)

// Exporting the request function directly for easier use
export const graphqlRequest = graphqlClient.request.bind(graphqlClient)
